module.exports = __webpack_public_path__ + "static/media/people-transparent.d2705704.svg";